import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

export interface SchaefflerTopBannerData {
  uid: string;
  content?: string;
  iconUrl?: string;
  showRemainingTime: boolean;
  campaign?: {
    code: string;
    startDate?: number;
    endDate?: number;
    url: string;
  };
}
export function createSchaefflerTopBannerComponent(json: string) {
  const data = JSON.parse(json) as SchaefflerTopBannerData;
  addBanner(data);

  return null;
}

let externalBannerList: SchaefflerTopBannerData[] = [];
const setterList: Dispatch<SetStateAction<SchaefflerTopBannerData[]>>[] = [];

const addBanner = (banner: SchaefflerTopBannerData) => {
  externalBannerList = [...externalBannerList, banner];
  setterList.forEach((setter) => setter(externalBannerList));
};

export function useSchaefflerTopBannerList() {
  const [bannerList, setBannerList] = useState<SchaefflerTopBannerData[]>(() => externalBannerList);

  useEffect(() => {
    setterList.push(setBannerList);
    return () => {
      setterList.splice(setterList.indexOf(setBannerList), 1);
    };
  }, []);

  return bannerList;
}
